const header = document.querySelector(".js-header");

export function init() {
    // Use animationFrame to check if window is scrolled and if so add
    // stuck data attribute to header
    window.addEventListener("scroll", () => {
        if (!window.requestAnimationFrame) {
            return;
        }

        window.requestAnimationFrame(() => {
            if (window.scrollY >= 16) {
                header.setAttribute("data-stuck", true);
            } else {
                header.removeAttribute("data-stuck");
            }
        });
    });
}
